import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getNft} from '../../../apis/unknownorder/nft'

const useQueryNft = (currentPage: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getNft(currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getNft(currentPage)
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryNft
